/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {  FetchModelResponse,  IFetchModel } from '@cian/http-api'
import type {  ISuggestV2Response } from '../../entities/entities/SuggestV2Response'
import type {  IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema'


export interface ISuggestRequest  {
count?: number;
dealType?: EQueryParameters;
isCoworkingSearch?: boolean;
isDailyRent?: boolean;
offerType: EQueryParameters_1;
query: string;
regionId: number;
source?: EQueryParameters_2;

}

export enum EQueryParameters {
/** Аренда **/
'Rent' = 'rent',
/** Покупка **/
'Sale' = 'sale',

}
export enum EQueryParameters_1 {
/** Квартиры **/
'Flat' = 'flat',
/** Загородка **/
'Suburban' = 'suburban',
/** Коммерческая **/
'Commercial' = 'commercial',
/** Новостройки **/
'Newobject' = 'newobject',

}
export enum EQueryParameters_2 {
/** С главной **/
'Mainpage' = 'mainpage',
/** С поиска **/
'Serp' = 'serp',
/** С карты **/
'Map' = 'map',
/** С мобильного сайта **/
'MobileWebsite' = 'mobileWebsite',
/** Из коммерческой недвижимости **/
'IapMap' = 'iapMap',
/** Страница акций в новостройках **/
'NewbuildingPromosPage' = 'newbuildingPromosPage',

}
export type TSuggestResponse = FetchModelResponse<200, 'json', ISuggestV2Response>|FetchModelResponse<400, 'json', IErrorResponseSchema>


export type TSuggestModel = IFetchModel<ISuggestRequest, undefined, TSuggestResponse>

export interface IMappers <TResponse200, TResponse400> {
200(response: ISuggestV2Response, headers: Headers): TResponse200;
400(response: IErrorResponseSchema, headers: Headers): TResponse400;

}
